// @ts-check
import { reject, find, propEq } from 'ramda'
const userStatusStrings = require('./statuses')
import addExperienceTemplate from './add-experience/add-experience.html'
import addExperienceController from './add-experience/add-experience.ctrl.js'
import resumeController from '../resume/resume.ctrl'
import resumeTemplate from '../resume/resume.html'
import paystubController from './paystub/paystub.ctrl'
import paystubTemplate from './paystub/paystub.html'
import editAddressController from './edit-address/edit-address.ctrl'
import editAddressTemplate from './edit-address/edit-address.html'
import editPhoneController from './edit-phone/edit-phone.ctrl'
import editPhoneTemplate from './edit-phone/edit-phone.html'
import editBioController from './edit-bio/edit-bio.ctrl'
import editBioTemplate from './edit-bio/edit-bio.html'
import directDepositController from './direct-deposit/direct-deposit.ctrl'
import directDepositTemplate from './direct-deposit/direct-deposit.html'

class Profile {
  /**
   * @type {PayrollClient}
   */
  payrollClient
  /* @ngInject */
  constructor (Auth, UsersService, JobsService, CompaniesService, ReferenceService, $mdDialog, $rootScope, $state, $mdToast, $window, $ocLazyLoad, PermRoleStore, PayrollService, $stateParams, Paystub, PayrollClient) {
    this.Auth = Auth
    this.contentLoaded = false
    this.UsersService = UsersService
    this.PayrollService = PayrollService
    this.JobsService = JobsService
    this.CompaniesService = CompaniesService
    this.payrollClient = PayrollClient
    this.$state = $state
    this.$stateParams = $stateParams
    this.$mdToast = $mdToast
    this.$ocLazyLoad = $ocLazyLoad
    this.$window = $window
    this.PermRoleStore = PermRoleStore
    this.loadingSemaphore = false
    this.$mdDialog = $mdDialog
    this.details = {}
    this.profile = {}
    this.skills = []
    this.certifications = []
    this.favoritedByCompanies = []
    this.lifetimePoints = 0
    // eslint-disable-next-line no-undef
    this.googleMapsUrl = `https://maps.googleapis.com/maps/api/js?key=${CONFIG.GOOGLE_API_KEY}&libraries=places`

    this.userAccounts = []

    this.isPlaidEnabled = false

    this.userId
    this.details.profilePic = ''
    this.Paystub = Paystub

    this.loaderTemplate = `
    <md-dialog style="background-color:transparent;box-shadow:none; overflow: hidden;" layout-align="center center">
      <div class="loader-background" layout="column" layout-align="center center">
        <img class="loader-logo" src="images/bluecrew-logo.svg"/>
        <md-progress-linear md-mode="indeterminate" style="max-width:130px">
        </md-progress-linear>
      </div>
    </md-dialog>`

    ReferenceService.getSkills()
      .then(result => {
        this.definedSkills = result
        return
      })
    this.userStatusStrings = userStatusStrings

    // Global route change loading indicator.
    $rootScope.$on('user:loading:start', this.showLoader.bind(this))

    $rootScope.$on('user:loading:done', this.hideLoader.bind(this))

    $rootScope.$on('user:authenticated', () => {
      this.authenticated = true
      this.Auth.getDetails()
      .then(result => {
        this.details = result
        if (this.details.phone) {
          this.details.phone = this.details.phone.replace(/^0+/, '')
          this.details.formattedPhone = this.formatPhone(this.details.phone.slice(1))
        }

        this.details.pointsHistory.forEach(p => {
          if (p.value > 0) {
            this.lifetimePoints += p.value
          }
        })
        this.userId = this.details.internalId
        this.levels = this.details.levels
        this.pointsTotal = parseInt(this.details.pointsTotal)
        this.levelLogos = ['images/skill-svg/Certified.svg',
        'images/skill-svg/Elite.svg',
        'images/skill-svg/Recruit.svg',
        'images/skill-svg/Champion.svg',
        'images/skill-svg/Hall Of Fame.svg']
        this.externalUserId = this.details.id
        this.populateProfile()
        this.populateOnarollResources()
        if (this.$stateParams.tab === 'overview') { this.selectedTab = 0 }
        if (this.$stateParams.tab === 'payments') { this.selectedTab = 1 }
        if (this.$stateParams.tab === 'career') { this.selectedTab = 2 }
        if (this.$stateParams.tab === 'points') { this.selectedTab = 3 }
        if (this.$stateParams.tab === 'resume') { this.selectedTab = 4 }
        if (this.$stateParams.tab === 'signup') { this.selectedTab = 5 }
        if (this.$stateParams.tab === 'rewards')  { this.selectedTab = 6 }
      })
    })

    if (this.Auth.loggedIn()) {
      $rootScope.$broadcast('user:authenticated')
    }

    this.workHistoryLengthOptions = {
      0: '3 month',
      1: '3-6 month',
      2: '6-12 months',
      3: '1-2 years',
      4: '2+ years'
    }
    this.rewards = [
      {
        text: 'Food Handlers Card',
        value: 100,
        color: '#cbdee7'
      },
      {
        text: 'Profile Revamp',
        value: 200,
        color: '#cbdee7'
      },
      {
        text: '$15 Swag Bucks',
        value: 300,
        color: '#98becf'
      },
      {
        text: 'Referral Business Cards',
        value: 400,
        color: '#98becf'
      },
      {
        text: 'Alcohol Server Training',
        value: 650,
        color: '#5492af'
      },
      {
        text: 'Food Manager Safety Training',
        value: 700,
        color: '#efa15d'
      },
      {
        text: 'Forklift Certification',
        value: 700,
        color: '#efa15d'
      }
    ]
  }

  populateProfile () {
    // (uncommon enough to point out) eacn of these then blocks
    // isn't returned or chained. in other words, these are all
    // things happening in parallel to one another. Things with
    // dependencies appear to be nested chains within the top-level
    // ones.
    this.UsersService.getWorkHistory(this.userId)
      .then(result => {
        this.workHistory = result
        if (!this.checkrData && this.details.checkr_id) {
          this.UsersService.getCheckrData(this.details.checkr_id)
          .then(result => {
            this.checkrData = result
            this.contentLoaded = true
            return
          })
        } else {
          this.contentLoaded = true
          return
        }
      })
    .then(() => {
      this.UsersService.getUserProfile(this.userId)
      .then(result => {
        this.profile = result
        const allSkills = []
        this.profile.skillsByJobType.forEach(category => {
          category.skills.forEach(s => {
            allSkills.push(s.name)
          })
        })
        allSkills.sort()
        // split skills in 2 columns
        this.skillsInPairs = []
        if (allSkills.length > 0) {
          let pairOfSkills = ['', '']
          for (let i = 0; i < allSkills.length; i++) {
            if (i % 2 === 0) {
              pairOfSkills = [allSkills[i], '']
              if (i === allSkills.length - 1) {
                this.skillsInPairs.push(pairOfSkills)
              }
            } else {
              pairOfSkills[1] = allSkills[i]
              this.skillsInPairs.push(pairOfSkills)
            }
          }
        }
        this.certifications = result['certs']
        this.UsersService.getSkillsQuizzes(this.userId)
        .then(result => {
          this.quizzes = result
          this.unfinishedQuizzes = find(propEq('completed_at', null), this.quizzes)
          if (this.unfinishedQuizzes && this.profile.highest_cm_app_version.split('.')[0] < 7) {
            // if we're in pre-7 app land, we just select the skills/questions tab.
            this.selectedTab = 5
          } else if (this.unfinishedQuizzes) {
            if (this.unfinishedQuizzes.stage_id !== 7) {
              // unless this is an i9 reupload, we should ignore it
              this.quizzes = undefined
              this.unfinishedQuizzes = undefined
            } else {
              // legacy behavior to autoselect tab for id=7
              this.selectedTab = 5
            }
          }
        })
      })
    })
    .then(() => {
      this.UsersService.favoritedByCompanies(this.userId)
      .then(result => {
        this.favoritedByCompanies = result
      })
    })
    .then(() => {
      this.UsersService.getBankAccounts(this.userId)
      .then(result => {
        this.bankAccounts = result.map(a => { a.type = a.type.toLowerCase(); return a })
      })
    })
    .then(() => {
      this.PayrollService.getUserPaystub({ userId: this.externalUserId })
      .then(result => {
        this.paystubs = result
      })
    })
  }

  showResume () {
    const parentEl = document.body
    this.$mdDialog.show({
      parent: parentEl,
      fullscreen: true,
      locals: {
        worker: this.UsersService.getProfile(this.externalUserId),
        application: this.UsersService.fetchApplication(this.externalUserId),
        inModal: true
      },
      template: resumeTemplate,
      controller: resumeController,
      controllerAs: 'w'
    })
  }

  showPaystub (paystub) {
    const parentEl = document.body
    this.$mdDialog.show({
      parent: parentEl,
      fullscreen: true,
      locals: {
        paystub,
        checkrData: this.checkrData || null,
        user: this.details,
        inModal: true
      },
      template: paystubTemplate,
      controller: paystubController,
      controllerAs: 'w'
    })
  }

  uploadProfilePicture () {
    this.$window.webkit.messageHandlers.uploadPicture.postMessage('uploadPicture')
  }

  editBio () {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      template: editBioTemplate,
      locals: {
        user: this.details
      },
      controller: editBioController,
      controllerAs: 'ctrl'
    }).then(userBio => {
      this.details.bio = userBio
    }).catch(_ => {})
  }

  editPhone () {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      template: editPhoneTemplate,
      locals: {
        username: this.details.username
      },
      controller: editPhoneController,
      controllerAs: 'ctrl'
    })
  }

  editAddress () {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      template: editAddressTemplate,
      locals: {
        user: this.details
      },
      controller: editAddressController,
      controllerAs: 'ctrl'
    }).then(updatedAddress => {
      this.details.address = updatedAddress.address
      this.details.apartment = updatedAddress.apartment
      this.details.city = updatedAddress.city
      this.details.state = updatedAddress.state
      this.details.zipcode = updatedAddress.zipcode
    }).catch(_ => {})
  }

  addExperience ($event) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      template: addExperienceTemplate,
      fullscreen: true,
      multiple: true,
      clickOutsideToClose: true,
      locals: {
        prevJobInfo: {},
        user: this.details,
        edit: false,
        skillsObj: this.definedSkills
      },
      controller: addExperienceController,
      controllerAs: 'q'
    })
    .then(data => {
      this.workHistory = data
      this.prevJobInfo = {}
      this.prevJobInfo.skills = []
    })
    .catch((err) => {
      console.error(err)
      this.$mdToast.showSimple('no work history added')
    })
  }

  showDirectDepositDialog () {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      template: directDepositTemplate,
      locals: {
        userId: this.userId
      },
      controller: directDepositController,
      controllerAs: 'ctrl'
    })
  }

  editWorkHistory ($event, workHistoryId) {
    const parentEl = document.body
    this.prevJobInfo = find(propEq('id', workHistoryId), this.workHistory)
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      template: addExperienceTemplate,
      fullscreen: true,
      multiple: true,
      clickOutsideToClose: true,
      locals: {
        prevJobInfo: this.prevJobInfo || {},
        user: this.details,
        edit: true,
        skillsObj: this.definedSkills
      },
      controller: addExperienceController,
      controllerAs: 'q'
    })
    .then(newWorkHistory => {
      this.workHistory = newWorkHistory
      this.prevJobInfo = {}
      this.prevJobInfo.skills = []
    })
    .catch((err) => {
      console.error(err)
      this.$mdToast.showSimple('no work history added')
    })
  }

  initializePlaid () {
    this.isPlaidEnabled = this.Auth.splitClient.getTreatment('plaid-enabled', {internal_id: this.userId}) === 'on';

    if (!this.isPlaidEnabled) {
      return;
    }

    this.payrollClient.createPlaidLinkToken().then((response) => {
      const linkConfig = {
        token: response.data.link_token,
        receivedRedirectUrl: this.$window.location.href,
        onSuccess: (public_token, metadata) => {
          if (metadata.accounts.length === 0) {
            return this.$mdToast.showSimple('You didn\'t select an account')
          }
          const account = metadata.accounts[0];
          // For the future if we want to allow multiple bank account deposits
          // metadata.accounts.forEach((account) => {
          //   account.calculation_method = 0
          //   account.percentage = null
          //   account.amount = null
          //   this.selectedAccounts.push(account)
          // })
          // if (metadata.accounts.length === 1) {
          //   this.plaidSaveAccount(metadata)
          // } else {
          //   // For the future if we want to mallow multiple bank account deposits
          //   this.showAccountBreakout = true
          // }
          account.calculation_method = 0
          account.percentage = null
          account.amount = null

          const plaidPayload = {
            public_token,
            accounts: metadata.accounts,
            institution: metadata.institution
          }
          this.plaidSaveAccount(plaidPayload)
        },
        onExit: async (err, metadata) => {
          // The user exited the Link flow with an INVALID_LINK_TOKEN error.
          // This can happen if the token expires or the user has attempted
          // too many invalid logins.
          if (err != null && err.error_code === 'INVALID_LINK_TOKEN') {
            this.plaidLink.destroy();
            this.plaidLink = this.$window.Plaid.create({
              ...linkConfig,
              // Fetch a new link_token because the old one was invalidated.
              token: await this.payrollClient.createPlaidLinkToken(),
            });
          } else {
            throw err
          }
          // metadata contains the most recent API request ID and the
          // Link session ID. Storing this information is helpful
          // for support.
        },
      }

      this.plaidLink = this.$window.Plaid.create(linkConfig)
    })
  }

  openPlaid () {
    if (!this.isPlaidEnabled) {
      return this.showDirectDepositDialog()
    }
    this.plaidLink.open()
  }

  plaidSaveAccount (plaidPayload) {
    this.$mdDialog.show({
      template: this.loaderTemplate,
      parent: document.body
    })

    this.PayrollService.plaidSaveAccount(this.userId, plaidPayload)
      .then((result) => {
        this.$mdDialog.hide()
        this.details.hasDirectDeposit = true
        this.$mdToast.showSimple('Direct deposit info saved')
        window.location.href = window.location.href + '?tab=payroll'
      }, (req, data, status) => {
        this.$mdDialog.hide()
        this.$mdToast.showSimple('Unable to save info...')
      })
  }

  showLoader () {
    if (!this.loadingSemaphore) {
      this.$mdDialog.show({
        template: this.loaderTemplate,
        parent: document.body
      })
    }
    this.loadingSemaphore = true
  }

  hideLoader () {
    this.loadingSemaphore = false
    this.$mdDialog.hide()
  }

  formatPhone (phone) {
    if (phone.length < 10 || phone.length > 11 || !phone.match(/^[0-9]*$/)) {
      return phone
    }
    if (phone.length === 10) {
      return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`
    }
  }

  activateBankAccount (bankAccountId) {
    this.UsersService.activateBankAccount(this.userId, bankAccountId)
    .then(() => {
      this.bankAccounts = this.bankAccounts.map(a => {
        a.active = a.id === bankAccountId
        return a
      })
      this.$mdToast.showSimple('Bank account activated.')
    })
    .catch(() => {
      this.$mdToast.showSimple('Unable to activate bank account.')
    })
  }

  deleteBankAccount (bankAccountId, accountNumber) {
    this.$mdDialog.show(
      this.$mdDialog.confirm()
      .title(`Are you sure you want to disconnect your bank account ending in ${accountNumber}? Note: Please give 24 hours for these changes to reflect in Paylocity`)
      .ariaLabel('Confirm bank account deletion')
      .ok('OK')
      .cancel('Cancel')
    )
    .then(() => {
      this.UsersService.deleteBankAccount(this.userId, bankAccountId)
      .then(() => {
        this.bankAccounts = reject(a => a.id === bankAccountId, this.bankAccounts)
        this.$mdToast.showSimple('Bank account deleted.')
      })
      .catch(() => {
        this.$mdToast.showSimple('Unable to delete bank account.')
      })
    })
  }

  calculateStartDate (date) {
    return this.Paystub.calculateStartDate(date)
  }

  populateOnarollResources () {
    this.onarollLogo = CONFIG.CM7_WEB_URL + '/assets/icons/onaroll.svg'
    this.onarollPerks = CONFIG.CM7_WEB_URL + '/assets/icons/onaroll-perks.png'
    this.onarollButtonText = 'Go to Bluecrew Rewards'
  }

  openOnarollRewards () {
    window.open('https://app.onaroll.co/', '_blank')
  }

  getCovidMessaging () {
    if (this.details.covidVaccinationDate) {
      // Set messaging to 14 days after last vaccination
      let fullyVaccinatedDate = new Date(this.details.covidVaccinationDate)
      fullyVaccinatedDate.setDate(fullyVaccinatedDate.getDate() + 14)
      return `Fully vaccinated as of ${fullyVaccinatedDate.toDateString()}`
    } else if (this.details.covidExemptionApprovedDate) {
      return 'Medically or religiously exempt'
    } else {
      return  'Submit proof of vaccination via the dashboard'
    }
  }

}

export default Profile
